module.exports = __webpack_public_path__ + "static/img/coming-soon.2500498f.svg";